import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { STYLES } from '../constants';
import Icon from '../../../generic-components/Icon';
import zeroStateIcon from '../../../assets/icons/svg/large-icons/ic-large-categorization-cards.svg';
import { useStore } from '../../../store';
import { PROFILE_TYPES } from '../../../constants/general';

interface IProps {
    containerClassName: string;
    shouldShowHeader: boolean;
    containerHeader: string;
}

export const ZeroState = ({
  containerClassName, shouldShowHeader, containerHeader,
}: IProps) => {
  const { t } = useTranslation();
  const summaryData = useStore(state => state.getSummaryData());

  const titleMap = {
    [PROFILE_TYPES.BASIC]: t('CATEGORIZE_EXPENSES_COMPONENT_ZERO_STATE_BASIC'),
    [PROFILE_TYPES.PRO]: t('CATEGORIZE_EXPENSES_COMPONENT_ZERO_STATE_PRO'),
    [PROFILE_TYPES.PRO_V2]: t('CATEGORIZE_EXPENSES_COMPONENT_ZERO_STATE_PRO'),
    [PROFILE_TYPES.SMART]: t('CATEGORIZE_EXPENSES_COMPONENT_ZERO_STATE_SMART'),
    [PROFILE_TYPES.PREMIUM]: t('CATEGORIZE_EXPENSES_COMPONENT_ZERO_STATE_SMART'),
  };

  const dynamicTitle = useMemo(() => {
    const type = summaryData?.customerProfileInfo?.customerProfile;
    return titleMap[type];
  }, [summaryData]);

  return (
    <div className={containerClassName}>
      {shouldShowHeader && containerHeader && (
        <Heading
          title={containerHeader}
          className={STYLES.MAIN_TITLE}
        />
      )}
      <div className='min-h-[350px] flex flex-col items-center justify-center'>
        <div className='max-w-[60%] w-[60%]'>
          <Icon className='w-full object-contain mb-[24px]' src={zeroStateIcon} />
        </div>
        <Heading
          title={dynamicTitle}
          className='text-center font-metric text-[14px] text-bw05 w-[80%]'
        />
      </div>
    </div>
  );
};
